import { Injectable, Compiler, Inject, ReflectiveInjector, Injector, COMPILER_OPTIONS } from '@angular/core';
import {HttpClient} from '@angular/common/http';
//import 'rxjs/add/operator/map';

// Needed for the new modules
import * as AngularCore from '@angular/core';
import * as AngularCommon from '@angular/common';
import * as AngularRouter from '@angular/router';
//import * as AngularClarity from '@clr/angular';
import * as BrowserAnimations from '@angular/platform-browser/animations';
import * as RxJsModule from 'rxjs';
import * as InputTextModule from 'primeng/inputtext';
import * as ButtonModule from 'primeng/button';
import * as CheckBoxModule from 'primeng/checkbox';
import * as TableModule from 'primeng/table';
import * as ListBoxModule from 'primeng/listbox';
import * as TagModule from 'primeng/tag';
import * as AfmComponentsModule from 'afm-components/';
import * as FormsModule from '@angular/forms';
import * as HttpClientModule from '@angular/common/http';
import { ItemsService } from '../commons/items.service';
import * as PrimengApi  from 'primeng/api';
import * as TSLibModule from 'tslib'
import * as InputSwitchModule from 'primeng/inputswitch';
import * as ConfirmDialogModule from 'primeng/confirmdialog';
import * as FieldsetModule from 'primeng/fieldset';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import* as FileUploadModule from 'primeng/fileupload';


declare const SystemJS:  any;

@Injectable({
    providedIn: 'root'
})
export class ModuleService {
    source = ItemsService.ROOT_URL+'process/';

    constructor(private compiler: Compiler, private http: HttpClient) {
    }

    loadModule(form: any): Promise<any> {
        let url = this.source + form.processId.path;
        return this.http.get<string>(url).toPromise()
            .then(res => res)
            .then(source => {
                const exports : any= {}; // this will hold module exports
                const modules : any = {   // this is the list of modules accessible by plugins
                    '@angular/core': AngularCore,
                    '@angular/common': AngularCommon,
                    '@angular/router': AngularRouter,
                    '@angular/platform-browser/animations': BrowserAnimations,
//                    '@clr/angular': AngularClarity
                };

                // shim 'require' and eval
                const require: any = (module) => modules[module];
                eval(source);

                // Need to check if there is another solution for eval as this is described as 'Evil'

                this.compiler.compileModuleAndAllComponentsSync(exports[`${form.processId.alias}`])
                return exports;
            });
    }

    loadModuleSystemJS(process: any): Promise<any> {
        let url = this.source +process.alias +'/'+process.location;
        SystemJS.set('@angular/core', SystemJS.newModule(AngularCore));
        SystemJS.set('@angular/common', SystemJS.newModule(AngularCommon));
        SystemJS.set('@angular/router', SystemJS.newModule(AngularRouter));
        SystemJS.set('rxjs', SystemJS.newModule(RxJsModule));
//        SystemJS.set('@angular/platform-browser/animations', SystemJS.newModule(BrowserAnimations));
        SystemJS.set('@angular/common/http', SystemJS.newModule(HttpClientModule));
        SystemJS.set('@angular/forms', SystemJS.newModule(FormsModule));
        SystemJS.set('primeng/inputtext', SystemJS.newModule(InputTextModule));
        SystemJS.set('primeng/button', SystemJS.newModule(ButtonModule));
        SystemJS.set('afm-components/', SystemJS.newModule(AfmComponentsModule));
        SystemJS.set('primeng/api', SystemJS.newModule(PrimengApi));
        SystemJS.set('primeng/checkbox', SystemJS.newModule(CheckBoxModule));
        SystemJS.set('primeng/table', SystemJS.newModule(TableModule));
        SystemJS.set('primeng/listbox', SystemJS.newModule(ListBoxModule));
        SystemJS.set('primeng/tag', SystemJS.newModule(TagModule));
        SystemJS.set('tslib', SystemJS.newModule(TSLibModule));
        SystemJS.set('primeng/inputswitch', SystemJS.newModule(InputSwitchModule));
        SystemJS.set('primeng/confirmdialog', SystemJS.newModule(ConfirmDialogModule));
        SystemJS.set('primeng/fileupload', SystemJS.newModule(FileUploadModule));
        SystemJS.set('primeng/fieldset', SystemJS.newModule(FieldsetModule));
        SystemJS.set('file-saver', SystemJS.newModule(FileSaver));
        SystemJS.set('xlsx', SystemJS.newModule(XLSX));
        // now, import the new module
        SystemJS.config({
            meta: {
            '*': { authorization: 'Bearer '+JSON.parse(localStorage.getItem("currentUser")).token,
                withCredentials :false,
                credentials: false,
                crossOrigin: 'anonymous'
            }
            },
        });
        return SystemJS.import(`${url}`).then((module) => {
            console.log(module);
            console.log(`${process.processTraitement}`);
            console.log(module[`${process.processTraitement}`]);
            return this.compiler.compileModuleAndAllComponentsAsync(module[`${process.processTraitement}`]).then(compiled => {
                console.log(compiled);
                return module;
            });
        });
    }
}